/*

----- Redirect ----- 
Takes a url provided by expressSelectors()['redirect']['url'] update the url then redirect.
*/

function redirect(context) {
    if (context == undefined) {
        AXISDebug.output(3,"Redirect: Context has not been provided.");
        return false;
    }
    // Get redurectly
    let url = context.attr(expressSelectors()['redirect']['url']);
    if (url == "" || url == undefined) {
        AXISDebug.output(3, "Redirect: Url not defined.");
        return false;
    }
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Redirect: Do a redirect to the following url ", url);
    }
    let update = updateUrl.set(context, true);
    // Reload tab to perform redirect.
    location.reload();
}


var AXISRedirect = $.AXISRedirect = {
    redirect: (context) => {
        return redirect(context);
    }
}
 
export { AXISRedirect };